import type { ReactNode } from 'react';

/**
 * The minimized state every banner shares: a small pill (icon + label)
 * that fades in once minimized and restores the banner on click. Kept
 * fully self-contained -- visibility is its own `--visible` modifier
 * rather than something a banner-specific ancestor class has to gate --
 * so it never has to know which banner it belongs to.
 */
export function BannerPill({
  visible,
  onClick,
  ariaLabel,
  icon,
  label,
}: {
  visible: boolean;
  onClick: () => void;
  ariaLabel: string;
  icon: ReactNode;
  label: string;
}) {
  return (
    <button
      type="button"
      className={`banner-pill ${visible ? 'banner-pill--visible' : ''}`.trim()}
      onClick={onClick}
      aria-label={ariaLabel}
      tabIndex={visible ? undefined : -1}
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}
